import Dispatcher from '../dispatcher'

export default {

	deactivateDevice(id) {
		Dispatcher.emit(Dispatcher.DEVICE_DEACTIVATE_DEVICE, id);
	}

}



/** WEBPACK FOOTER **
 ** ./src/js/actions/device-action.js
 **/